//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Object.js";
import "../no/ErrorList.js";
import "../no/Session.js";
let d=[[],[[["seedPart","tabName","relationType","templateApplication","itemType"],"CreateFileNewTemplateNode",{R_:{templateNode:"Gateway.FileNewTemplateNode"}},5,0],[["templateNode"],"SaveAsTemplate",{R_:{errorList:"ErrorList"}},1,0],[["templateNode"],"Free",{},1,0],[["s"],"RemoveManageTemplate",{},1,0]],[]];
SPLM.Gateway.FileNewTemplateManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Gateway.FileNewTemplateManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Gateway.FileNewTemplateManager.RemoveTemplateStruct = class{
    constructor(cliName,tabName){
        this.cliName=cliName;this.tabName=tabName;}
    get Cliname(){return this.cliName}
    set Cliname(val){this.cliName = val}
    get Tabname(){return this.tabName}
    set Tabname(val){this.tabName = val}
};

export default SPLM;